/** @jsxImportSource @emotion/react */
import { Autocomplete, Table, TableBody, TableRow, TableCell, OutlinedInput, Button, Link, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme, Divider, DialogContent, DialogActions, List, ListItem, ListItemText, TableHead, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { useNavigate } from 'react-router-dom';
import UploadIcon from "../../Components/DocumentUpload/UploadIcon"
import DialogForUpload from "../../Components/DocumentUpload/DialogForUpload"
import UploadDialog from "../../Components/DocumentUpload/UploadDialog"
import UploadPdf from "../../Components/DocumentUpload/UploadPdf"
import ProofDialog from "../../Components/DocumentUpload/ProofDialog"
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import CloseIcon from '@mui/icons-material/Close';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';
import Upload from '../../Components/Upload';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

var stageStatus;
var kraVerified;
const initialConsentCheckBox = {"creditPledgeInstruction": true,
    "electronicContractNoteNstatement": true,
    "shareEmailWithRegistrarNrta": true,
    "dividendInterestinBankAc": true,
    "internetTrading": true,
    "electronicAnnualReport": true,
    "rightObligation": true,
    "receiveDisslip": false,
    "dpAccountStatement": "As per SEBI Regulations",
    "casFlag": true,
    "pastAction": false,
    "pastActionReason":"",
    "casMode": "eCAS",
    "preferredDepository": "CDSL",
    "authRunningAccount": "Quarterly"
}

const initialDdpiConsentCheckBox = {
    "transferOfSecurities": true,
    "pledgingRepledgingOfSecurities": true,
    "mutualFundTransactions": true,
    "tenderingSharesInOpenOffers": true
}

function AddressDetails(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [options, setOptions] = useState()
    const [pincodeOptions, setPincodeOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState({ corr: false, perm: false });
    const [consentOpen, setConsentOpen] = useState(false);
    const [mitcConsentOpen, setMitcConsentOpen] = useState(false)
    const [mtfConsentOpen, setMtfConsentOpen] = useState(false)
    const [ddpiConsentOpen, setDdpiConsentOpen] = useState(false)
    const [isConsentSatisfied, setIsConsentSatisfied] = useState(false)
    const [isDDPIConsentSatisfied, setIsDDPIConsentSatisfied] = useState(false)
    const [ocrUploadLoading,setOcrUploadLoading] = useState(false)
    const navigate = useNavigate()

    const [id, setId] = useState();
    const [isEdit, setIsEdit] = useState(false)
    const [kRAData, setKRAData] = useState({})
    const [FATCAData, setFATCAData] = useState()
    const [openKRAVerifiedDataPopup, setOpenKRAVerifiedDataPopup] = useState(false)
    const [objectionState, setObjectionState] = useState({ "isObjection": false, "objections": [] })

    const [documentsUploadedDetails, setDocumentsUploadedDetails] = useState([])
    const [documentOf, setDocumentOf] = useState()
    const [documentOfScreen, setDocumentOfScreen] = useState()
    const [openInnerDialog, setOpenInnerDialog] = useState(false);
    const [documentTypeOption, setDocumentTypeOption] = useState();
    const [documentUploadedFor, setDocumentUploadedFor] = useState();
    const [showUploadPopup, setUploadPopup] = useState(false);
    const [image, setImage] = useState();
    const [pdf, setPdf] = useState();
    const [showPdfPopup, setPdfPopup] = useState(false);
    const [docMId, setDocMId] = useState()
    const [numberOfImages, setNumberOfImages] = useState(1)
    const [documentName, setDocumentName] = useState("");
    const [documentMappingKey, setDocumentMappingKey] = useState("");
    const [uploadedDocuments, setUploadedDocuments] = useState({ cpoa: [], ppoa: [] });
    const [showFields, setShowFields] = useState({ CPOA: false, PPOA: false, CPOAdisabled: false, PPOAdisabled: false })
    const localeText = useContext(Il8nContext)
    const [checkedField, setCheckedField] = useState(initialConsentCheckBox)
    const [isDdpiCheckedField, setisDdpiCheckedField] = useState(initialDdpiConsentCheckBox)
    const documentTypePerName = {
        "CPOA": "Corresponding Address",
        "PPOA": "Permanent Address",
        "POA": "Power of Attorney",
        "POI": "Proof Of Identity",
        "Sign": "Signature",
        "Photo": "Photograph",
        "KYCP": "KYC Proof",
        "DePr": "Demat Proof",
        "BaPr": "Bank Proof",
        "InPr": "Income Proof",
        "Nom": "Nominee Proof",
        "Gurd": "Guardian Proof",
        "IPV": "In-Person Verification",
        "KRA": "KYC KRA Page",
        "default": "Document Upload",
        "BalSh": "Copy of Balance sheet of past two years",
        "AuSig": "Authorised Signatory on letter head of Firm/Company",
        "ITR": "IT Return for last 2 financial years",
        "PDeed": "Partnership  deed",
        "PCapR": "Partnership capital ratio",
        "DMapL": "Demat account Mapping Letter",
        "MOA": "MOA and AOA of the company",
        "Annx": "Annexure page",
        "BoRes": "Board Resolution",
        "NetWo": "Net Worth Certificate",
        "RCert": "Registration Certificate",
        "Oth": "Others",
    }

    const documentICONS = {
        "CPOA": "/images/Address Proof.svg",
        "PPOA": "/images/Address Proof.svg",
        "POI": "/images/Photo ID Proof.svg",
        "Sign": "/images/Signature.svg",
        "Photo": "/images/Photo.svg",
        "BaPr": "/images/Bank-Proof.svg",
        "IPV": "/images/IPV (Video Recording).svg",
        "Oth": "/images/Signature.svg"
    }

    const MITCContentData=[
        {instruction:localeText?.consentAddressInstr1},
        {instruction:localeText?.consentAddressInstr2},
        {instruction:localeText?.consentAddressInstr3},
        {instruction:localeText?.consentAddressInstr4},
        {instruction:localeText?.consentAddressInstr5},
        {instruction:localeText?.consentAddressInstr6},
        {instruction:localeText?.consentAddressInstr7},
        {instruction:localeText?.consentAddressInstr8},
        {instruction:localeText?.consentAddressInstr9},
        {instruction:localeText?.consentAddressInstr10},
    ]


    const MTFConsentDataForClientRights = [
        {
            instruction: "Tradebulls Securities (P) Limited (Tradebulls) is eligible to provide Margin Trading Facility (MTF) in accordance with SEBI & Exchange Guidelines as specified from time to time."
        },
        {
            instruction: "Tradebulls is desirous of extending MTF to their Clients and has obtained prior permission of BSE and NSE for providing MTF to the Clients. The Exchanges have the right to withdraw the permission at anytime for sufficient reasons."
        },
        {
            instruction: "Tradebulls is permitted to extend MTF to the Clients on such terms and conditions as specified by the Stock Exchanges / SEBI from time to time and as mutually agreed by and between Tradebulls and the Clients. This Rights and Obligation comprises the terms and conditions applicable to MTF and Tradebulls and Clients shall abide by the same and any other requirements of the margin trading framework, including other rights and obligations, if any, prescribed by the Stock Exchange/ SEBI/ Tradebulls from time to time. Any modifications to the terms and conditions, other than those prescribed by SEBI/Stock Exchanges, shall be intimated to the Clients giving 15 days notice in advance."
        },
        {
            instruction: "Equity Shares that are classified as ‘Group I Security” by SEBI only shall be eligible for MTF. Tradebulls, at its discretion, may not provide funding under MTF to certain equity shares though classified to be “Group I Security” by SEBI. Equity shares shortlisted by Tradebulls for funding (Approved List) shall be as displayed on Tradebulls website www.tradebulls.in from time to time."
        },
        {
            instruction: "Initial margin, increased margin, margin shortage, margin calls, maximum allowable exposure, maximum stock specific exposure, trade confirmation, square off intimation and such other information in relation to MTF shall be communicated electronically through one or many or all of the following modes, viz email, SMS, WhatsApp, mobile notifications, and additionally through telephone calls."
        },
        {
            instruction: "In order to avail of margin facility, the minimum initial margin required to be provided by the Clients, as prescribed by SEBI/Stock Exchanges, is as under: VaR + 3 times of applicable ELM in case of F & O Stocks (i.e., stocks available for trading in the F&O Segment. VaR + 5 times of applicable ELM in case of stocks other than F & O Stocks. VaR and ELM shall mean VaR and ELM as applicable to respective stocks in the cash segment."        },
        {
            instruction: "Client shall be required to provide the minimum initial margin as applicable for a particular stock to buy that stock under MTF. The margin shall never be lower than that prescribed by the Stock Exchange/SEBI. However, Tradebulls shall have the right to demand a higher initial margin than the margin prescribed by SEBI/Stock Exchanges."
        },
        {
            instruction: "Subject to the initial margin as aforesaid, Tradebulls may, at its sole and absolute discretion, revise and increase from time to time the margin required for any stock permitted to be traded under MTF. Where Client has exposure in the stock in respect of which margin has been revised but does not already have sufficient credit in the account to meet increase in margin, Client shall pay margin found short within the time prescribed for making margin payment."        },
        {
            instruction: "Applicable minimum initial margin, increased margin, margin shortfall, if any, can be paid in the form of cash, cash equivalent, or Group I equity shares with appropriate hair cut as specified in SEBI Master Circular No. SEBI/HO/MRD/DP/CIR/P/2016/135, DTD. 16/12/2016. Client shall have the right to change collateral securities provided under the MTF with other collateral securities provided that such other collateral securities are approved and sufficient to meet the margin required."
        },
        {
            instruction: "Margin requirement on shares purchased under MTF shall be computed by grossing applicable margin i.e., minimum initial margin plus increased margin, if any, on each stock and shortage computed accordingly by deducting available margin from gross margin. Collateral shares and shares purchased under MTF (Funded Shares) shall be marked to market daily for the purpose of computing the margin/ shortage of margin."
        },
        {
            instruction: "Applicable minimum initial margin and increased margin, if any, shall be kept supplied at all times by the Clients in respect of the stocks purchased under the MTF. Client shall pay any shortage in the required margin immediately on receiving demand (margin call) and in any case not later than 11.00 P.M on the trade day following the day of making the margin call (prescribed time) failing which Tradebulls shall be at liberty to liquidate the funded shares and/or collateral shares to recover the dues outstanding in the account of the Clients. In case of extreme volatility in the market, Tradebulls may demand payment of margin forthwith and prescribed time for making margin payment shall be construed accordingly. Decision of Tradebulls in relation to market volatility shall be final and binding without Tradebulls having to provide any reason for the decision to the Client."
        },
        {
            instruction: "If required margin is not provided within the prescribed time,Client shall be treated as Client in margin default. Tradebulls shall not be obliged to notify the Client in margin default of the liquidation of shares, ahead of liquidation. Tradebulls shall not be obliged to liquidate shares proportionate to the shortage in margin."
        },
        {
            instruction: "Client in margin default shall continue to be in margin default, until the required margin is furnished in full to eliminate the shortage. Partial payment of margin or a change in the required margin shall not extend the time stipulated for making margin payment which will run from the time of making margin call to the Client."
        },
        {
            instruction: "In case margin is reduced by an amount equal to applicable ELM component of the total margin due to market volatility within a trading day (i.e. available margin becomes equal to or less than applicable VAR margin), Tradebulls reserves the right to liquidate the collaterals and/or funded shares forthwith without prior notice to the Client."
        },
        {
            instruction: "MTF Clients purchasing shares not specified in Tradebulls Approved List of Group 1 securities shall be required to 100% margin upfront for such purchases."
        },
        {
            instruction: "If any shares are delisted from Tradebulls Approved List,Client shall be required to make payment of full purchase consideration against such shares on receiving margin call within the prescribed time, failing which Tradebulls shall be at liberty sell such shares without further notice to the Client."
        },
        {
            instruction: "If a Client is debarred by orders of lawful authority from trading in the securities market, Tradebulls shall liquidate collateral and funded shares of the Client to recover its dues to the full extent forthwith."
        },
        {
            instruction: "In case of death of a Client, Tradebulls shall be entitled to liquidate the collateral and funded shares under MTF and recover the unpaid outstanding due."
        },
        {
            instruction: "Any loss arising from liquidation of the shares shall to be account of the Client. Client shall forthwith pay Tradebulls any unpaid dues outstanding in the account after liquidation of the shares."
        },
        {
            instruction: "Tradebulls reserves the right to withdraw MTF with respect to any Client without assigning any reason after giving a reasonable notice to the Client in which case dues if any outstanding in the account of the Client shall become payable immediately. Failure to make payment of the outstanding dues shall result in liquidation of collateral and/or funded shares held in Client’s account."
        },
        {
            instruction: "Client may terminate the MTF account after paying all dues in the MTF account."
        },
        {
            instruction: "Tradebulls shall not use the funds and securities of one Client to provide MTF to another Client, even on the authority of the Client."
        },
        {
            instruction: "The stocks deposited as margin collateral and funded stock shall be identifiable separately and no comingling shall be permitted for the purpose of computing funding amount."
        },
        {
            instruction: "Tradebulls may at its option allow Client to buy further shares under MTF on the basis of increase in the value of collateral shares, subject to applicable hair cut. Further purchase shall not be permitted on the basis of increase in the market value of funded shares."
        },
        {
            instruction: "PF shall not be available for transactions done on the Stock Exchange, through MTF, in case of any losses suffered in connection with the MTF availed by the client."
        },
        {
            instruction: "Tradebulls shall restrict the maximum gross exposure as well as individual stock-wise exposure of a client under the MTF at any point in time according to its internal policies and market views without assigning any reasons to the client. Furnishing applicable margin shall not by itself entitle the Client to seek exposure beyond the limit restricted by Tradebulls"
        },
        {
            instruction: "Admitting Clients for MTF shall be at the discretion of the Stock Broker/Trading Member. Clients request for admission to MTF may be disallowed without assigning any reason."
        },
        {
            instruction: "By agreeing to avail of MTF, the Client shall be deemed to have authorized Tradebulls to retain and/or pledge the shares purchased under MTF (funded shares) and collateral shares provided as margin till the amount due in respect of the purchase and all other dues are paid in full by the Client."
        },
        {
            instruction: "Tradebulls shall maintain separate ledgers for funds and securities of the client availing of MTF."
        },
        {
            instruction: "All outstanding dues under MTF shall carry interest of 0.06% per day + applicable taxes. However, if the debit is greater than Rs. 1 Crore, then the applicable interest shall be 0.08%% per day + applicable taxes."
        },
        {
            instruction: "Outstanding dues shall not be carried in the books beyond 90 days from the date of accrual and in case Client fails to pay up the dues within the said 90 days, collateral and/or funded shares shall be sold to liquidate the dues, even though applicable margin is available in the MTF account of the Client. For this purpose, 90 days shall be computed with respect to each debit entry in respect of purchases under MTF separately and liquidation shall be carried out accordingly. Tradebulls shall have discretion to sell any stock/stocks to liquidate the outstanding dues older than 90 days."
        },
        {
            instruction: "Client shall be free to take delivery of the shares purchased under MTF anytime, but not later than 90 days, from the date of funding by making full payment of the outstanding dues in relation to the shares purchased."
        },
        {
            instruction: "Until full payment of the outstanding dues in the MTF A/c is made by the Client, collateral shares and funded shares, as far as may be required, shall be retained in the Demat A/c of Tradebulls, separately identified as collateral shares and funded shares."
        },
        {
            instruction: "Daily margin statement sent to the MTF Clients shall identify margin/collateral for MTF transaction separately."
        },
        {
            instruction: "MTF account where there is no transaction under MTF for more than 90 days shall be settled immediately on expiry of said 90 days provided there are no dues outstanding in the MTF account. Dues if any outstanding in the normal trading account shall be first adjusted against the settlement amount and the remainder shall be paid to the Client."
        },
        {
            instruction: "Client admitted to MTF shall be deemed to have opted to treat unpaid shares held in Client’s account with Tradebulls as shares purchased in terms of the MTF and corresponding accrued outstanding dues shall be treated accordingly. In this case, Client shall furnish additional collateral shares, cash and/or cash equivalent required to bring up available margin to the level of initial minimum margin required under MTF, within the prescribed time after receiving margin call. Option to treat accrued outstanding dues as funding made under MTF shall be available only where the outstanding due is less than 90 days old."
        },
        {
            instruction: "In case Client does not opt for MTF, all dues on account of purchase of shares, accrued /accruing, shall be payable immediately/on or before T+7 failing which Tradebulls shall sell the shares to liquidate / reduce the dues and remaining unpaid dues, if any, shall become payable forthwith."
        },
        {
            instruction: "Tradebulls shall declare and communicate to the Client risk management policies that it will follow with respect to MTF transactions.Tradebulls may amend the policies from time to time according to its risk perceptions and inform the Clients of the amendments made."
        },
        {
            instruction: "Any disputes arising between the client and Tradebulls in connection with the margin trading facility shall be resolved through the investor grievance redressal mechanism and/ or arbitration mechanism of the stock exchanges as in the case of normal trades."
        },
        {
            instruction: "The Rights and Obligations prescribed herein above shall be read in conjunction with the rights & obligations as prescribed under SEBI circular No.CIR / MIRSD / 16 / 2011 dated August 22, 2011, SEBI Circular No.CIR / MRD / DP / 54 / 2017 Dtd.June 13, 2017, the Circulars relating to MTF issued by the respective Stock Exchanges, any modifications thereto from time to time and the Policies and Procedures prescribed by Tradebulls and the terms and conditions of client’s agreement with Tradebulls.In case of any inconsistencies between the Rights and Obligations herein and the provisions in the aforesaid SEBI and / or Stock Exchange Circulars, the later shall prevail to the extent of such inconsistencies."
        }
    ];
    
    const MTFConsentDataForClient = [
        {instruction:"Client shall receive all communications in a mode mutually agreed between the broker and the client regarding confirmation of orders/trades, margin calls, decision to liquidate the position/security."},
        {instruction:"Client shall be free to take the delivery of the securities at any time by repaying the amounts that was paid by the Stock Broker to the Exchange towards securities after paying all dues."},
        {instruction:"Client has a right to change the securities collateral offered for Margin Trading Facility at any time so long as the securities so offered are approved for margin trading facility."},
        {instruction:"Client may close / terminate the Margin Trading Account at any time after paying the dues."}
    ]
    
    const MTFConsentDataForClientObligations =[
        {instruction:"Client shall, in writing in his own hand or in any irrefutable electronic method, agree to avail of Margin Trading Facility in accordance with the terms and conditions of Margin Trading Facility offered by the broker, method of communication for confirmation of orders/trades, margin calls and calls for liquidation of collateral/security/position."},
        {instruction:"Client shall inform the broker of its intent to shift the identified transaction under Margin Trading Facility within the time lines specified by the broker failing which the transaction will be treated under the normal trading facility."},
        {instruction:"Client shall place the margin amounts as the Stock Broker may specify to the client from time to time."},
        {instruction:"On receipt of ‘margin call’, the client shall make good such deficiency in the amount of margin placed with the Stock Broker within such time as the Stock Broker may specify."},
        {instruction:"By agreeing to avail Margin Trading Facility with the broker, client is deemed to have authorized the broker to retain and/or pledge the securities provided as collateral or purchased under the Margin Trading Facility till the amount due in respect of the said transaction including the dues to the broker is paid in full by the client."},
        {instruction:"Client shall lodge protest or disagreement with any transaction done under the margin trading facility within the timelines as may be agreed between the client and broker."}
    ]

    const MTFConsentForStockBrokerRights=[
        {instruction:"Stock Broker and client may agree between themselves the terms and condition including commercial terms if any before commencement of MTF."},
        {instruction:"Stock broker may set up its own risk management policy that will be applicable to the transactions done under the Margin Trading Facility. Stock broker may make amendments there to at any time but give effect to such policy after the amendments are duly communicated to the clients registered under the Margin Trading Facility."},
        {instruction:"The broker has a right to retain and/or pledge the securities provided as collateral or the securities bought by the client under the Margin Trading Facility."},
        {instruction:"The broker may liquidate the securities if the client fails to meet the margin call made by the broker as mutually agreed of liquidation terms but not exceeding 5 working days from the day of margin call."},
    ]

    const MTFConsentForStockBrokerObligations =[
        {instruction:"Stock broker shall agree with the client the terms and condition before extending Margin Trading Facility to such client. However, for clients who already have existing trading relationship and want to avail of Margin Trading Facility, stock broker may take consent in writing in his own hand or in any irrefutable electronic method after stock broker has communicated the terms and conditions of Margin Trading Facility to such existing clients."},
        {instruction:"The terms and conditions of Margin Trading Facility shall be identified separately, in a distinct section if given as a part of account opening agreement."},
        {instruction:"The mode of communication of order confirmation, margin calls or liquidation of position/security shall be as agreed between the broker and the client and shall be in writing in his own hand or in any irrefutable electronic method. Stock broker shall prescribe and communicate its margin policies on haircuts/ VAR margins subject to minimum requirements specified by SEBI and exchanges from time to time."},
        {instruction:"The Stock Broker shall monitor and review on a continuous basis the client's positions with regard to MTF. It is desirable that appropriate alert mechanism is set up through which clients are alerted on possible breach of margin requirements."},
        {instruction:"Any transaction to be considered for exposure to MTF shall be determined as per the policy of the broker provided that such determination shall happen not later than T + 1 day."},
        {instruction:"If the transaction is entered under margin trading account, there will not be any further confirmation that it is margin trading transaction other than contract note."},
        {instruction:"In case the determination happens after the issuance of contract, the broker shall issue appropriate records to communicate to Client the change in status of transaction from Normal to Margin trading and should include information like the original contract number and the margin statement and the changed data."},
        {instruction:"The Stock Broker shall make a ‘margin call’ requiring the client to place such margin; any such call shall clearly indicate the additional / deficient margin to be made good."},
        {instruction:"Time period for liquidation of position/security shall be in accordance declared policy of the broker as applicable to all MTF clients consistently. However, the same should not be later than 5 working (trading) days from the day of ‘margin call’. If securities are liquidated, the contract note issued for such margin call related transactions shall carry an asterisk or identifier that the transaction has arisen out of margin call."},
        {instruction:"The daily margin statements sent by broker to the client shall identify the margin/collateral for Margin Trading separately."},
        {instruction:"Margin Trading Accounts where there was no transactions for 90 days shall be settled immediately."},
        {instruction:"The stocks deposited as collateral with the stock broker for availing margin trading facility (Collaterals) and the stocks purchased under the margin trading facility (Funded stocks) shall be identifiable separately and there shall not be any comingling for the purpose of computing funding amount;"},
        {instruction:"Stock Broker shall close/terminate the account of the client forthwith upon receipt of such request from the client subject to the condition that the client has paid dues under Margin Trading Facility."}
        ]

    const MTFConsentForTerminationOfRelation =[
        {instruction:"The margin trading arrangement between the stock broker and the client shall be terminated; if the Stock Exchange, for any reason, withdraws the margin trading facility provided to the Stock Broker or the Stock Broker surrenders the facility or the Stock Broker ceases to be a member of the stock exchange."},
        {instruction:"The MTF facility may be withdrawn by the broker, in the event of client committing any breach of any terms or conditions therein or at anytime after due intimation to client allowing such time to liquidate the MTF position as per the agreed liquidation terms without assigning any reason. Similarly, client may opt to terminate the margin trading facility in the event of broker committing any breach of any terms or conditions therein or for any other reason."},
        {instruction:"In the event of termination of this arrangement, the client shall forthwith settle the dues of the Stock Broker. The Stock Broker shall be entitled to immediately adjust the Margin Amount against the dues of the client, and the client hereby authorizes the Stock Broker to make such adjustment."},
        {instruction:"After such adjustment, if any further amount is due from the client to the Stock Broker, the client shall settle the same forthwith. Upon full settlement of all the dues of the client to the Stock Broker, the Stock Broker shall release the balance amount to the client."},
        {instruction:"If the client opts to terminate the margin trading facility, broker shall forthwith return to the client all the collaterals provided and funded securities retained on payment of all the dues by clients."},
    ]

    const MTFConsentMarginTradingQuestions = [
        {instruction:"How do I activate Margin Trading Facility?"},
        {instruction:"How long will it take to activate MTF Product after giving request/consent to enable it?"},
        {instruction:"What are the benefits of MTF?"},
        {instruction:"Which securities are eligible for margin trading?"},
        {instruction:"How can I purchase shares under MTF Facility?"},
        {instruction:"Do I need to do any process once I place order under MTF product?"},
        {instruction:"When will I received MTF pledge link for my MTF trades?"},
        {instruction:"What is the deadline to complete MTF pledge process?"},
        {instruction:"How long can I carry forward the debit/ outstanding amount in my account?"},
        {instruction:"When will I start incurring Interest Charges?"},
        {instruction:"What is margin required?"},
        {instruction:"Will I be allowed to fresh position in Margin Trading if I have not pledged my previous position?"},
        {instruction:"What can be done if the client fails to meet the margin call?"},
        {instruction:"Can I use Margin Trading Facility for Derivatives trading?"},
        {instruction:"Is Short-Selling allowed in Margin Trading Facility?"},
        {instruction:"Can the funded stocks and collaterals be comingled?"},
        {instruction:"Can I request for release of shares from MTF?"},
        {instruction:"Can I close/ suspend the MTF funding facility offered by the company?"},
        {instruction:"What is the rate of interest for MTF?"},
        {instruction:"What happens if any scrip funded in MTF is delisted from Tradebulls approved list?"},
        {instruction:"How interest on MTF is calculated?"},
        {instruction:"Can client take funds payout by keeping debit in MTF?"}
    ]

    const MTFConsentForTermsofTBAnswer=[
        {instruction:["Follow the below given steps to activate Margin Trading Facility from:","Go to web links: https://www.tradebulls.in/?MTFActivation.","Login to Tradebulls backoffice ","Accept Terms and Conditions for Margin Trading in the pop-up window that you come across."]},
        {instruction:"If you have given your consent by any of the above modes before 5 PM (working day), your request will be processed at the end of day and you will be able to use MTF product from next working day. Requests received after 5 PM (Working day) will be processed on the next working day and you will be able to use the Margin Trading facility on T+2 day onwards."},
        {instruction:["MTF eliminates the problem of insufficient funding while you place a delivery trade.","Up to 4x leverage.","Longer holding period." ,"Easy Pledge process.","No hidden charges"]},
        {instruction:"All the equity shares that are classified as Group I security as per Section 1.1.3 of Chapter IV of SEBI Master circular No. SEBI/ HO/ MRD/ DP/ CIR/ P/ 117 dated October 25, 2019 (previous SEBI circular ref. no. SEBI/HO/MRD/DP/CIR/P/2016/135 dated December 16, 2016) and Tradebulls reserves rights to exclude any scrip from the approved scripts list as per internal risk policy."},
        {instruction:"While placing purchase order in your trading application, select product as MTF and trade."},
        {instruction:"You MTF transaction is completed once MTF pledge OTP authentication is completed, on contrary trades will be marked as normal trade and client is required to make full payment before T+5 to avoid square off."},
        {instruction:"You will received MTF pledge OTP link from CDSL on same day of trade through SMS & EMAIL, however user can also visit CDSL website https://www.cdslindia.com/Authentication/OTP.aspx?id=P for MTF pledge OTP authentication"},
        {instruction:"You need to pledge your respective shares by 9:00 pm on same day of trade. In case you do not pledge the shares then debit in client books will be cleared on T+5."},
        {instruction:"You can hold your positions under MTF as long as you maintain the required margin in your account."},
        {instruction:"Interest is levied from the settlement day onwards after you placed an MTF trade, till the outstanding amount is cleared, and/or your position is squared-off"},
        {instruction:"The margin required is margin payable by the client to buy stocks under MTF product. The margin can be paid in the form of funds, or by pledging your approved holding."},
        {instruction:"Yes, you take fresh position as long as you have sufficient margin available in your account"},
        {instruction:"In case margin maintained by client falls below the required margin, Tradebulls will make a Margin Call and the position can be liquidated. Margin call/ liquidation can be made at any point of time when margins are not in place"},
        {instruction:"No, Margin Trading facility is available only for Cash segment."},
        {instruction:"No, Short - Selling is not allowed in Margin Trading Facility."},
        {instruction:"The stocks pledged as collateral with for availing margin trading facility and the stocks purchased under the margin trading facility shall be identifiable separately and there shall not be any comingling for the purpose of computing funding amount"},
        {instruction:"Yes, client can request for release of shares once funded value is paid by clients."},
        {instruction:"Yes, the client can close or suspend the Margin trading account at any time after paying the dues."},
        {instruction:"Currently the rate of interest is 0.06% Per Day applicable to account, further Tradebulls reserves rights to revise ROI as and when deemed necessary."},
        {instruction:"If any shares are delisted from Tradebulls Approved List, Client shall be required to make payment of full purchase consideration against such shares on receiving margin call within the prescribed time, failing which Tradebulls shall be at liberty sell such shares without further notice to the Client."},
        {instruction:"Interest on MTF will be calculated on net basis, where interest will be posted to client after adjusting any excess credit balance in broking books against MTF debit."},
        {instruction:"No, Payout can be given payout will be given to client on net basis i.e. Broking ledger + MTF ledger shall be in credit then only client will be eligible for payout."}
    ]

    const getLastDateOfFinancialYear = () => {
        const currentMonth = new Date().getMonth();
        const networthDate = new Date(currentMonth>2 ? (new Date().getFullYear()) : (new Date().getFullYear()-1), 2, 31).getTime();
        return networthDate
    };

    useEffect(() => {
        getFATCAOptions()
        getStageDetails()
        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection => objection.navigationPath == "/AddressDetails")

        if (objections?.length > 0) {
            objections = objections.map(objection => {
                return {
                    "objectionDescription": objection.objectionDescription,
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection => {
                if (objection.navigationPath == "/AddressDetails") {
                    objection.isNavigationDone = true;
                }
                return objection
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection: true, objections })
        }
    }, [])


    useEffect(() => {
        getAllAdressData()
    }, [uploadedDocuments])

    useEffect(() => {
        const ignoreConsent = ["authRunningAccount"]
        var tempinitalConsent = {...initialConsentCheckBox}
        var tempcheckfield = {...checkedField}
        ignoreConsent.map(consent =>{
            delete tempinitalConsent[consent]
            delete tempcheckfield[consent]
        })
        setIsConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
    }, [checkedField])

    useEffect(() => {
        var tempinitalConsent = {...initialDdpiConsentCheckBox}
        var tempcheckfield = {...isDdpiCheckedField}
        setIsDDPIConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
    }, [isDdpiCheckedField])

    const getAllAdressData = (uploadedDoc) =>{
        let fields = { ...showFields };
        if (Object.keys(uploadedDocuments)?.length > 0 || Object.keys(uploadedDoc)?.length > 0) {
            let cpoaDocs = uploadedDoc || uploadedDocuments || []
            if (cpoaDocs?.cpoa?.length > 0) {
                fields.CPOA = true
                // fields.CPOAdisabled=false
                let CPOAData = cpoaDocs?.cpoa?.filter(item => {
                    if (item?.ocrDetails?.address_pin) {
                        return item.ocrDetails
                    }
                })
                CPOAData?.length > 0 && getAllOCRDetails(CPOAData[0]?.ocrDetails || {}, 'cpoa')
            } else if (cpoaDocs?.cpoa?.length === 0 && stageStatus?.status == 0) {
                fields.CPOA = false
            }
            let ppoaDocs = uploadedDoc || uploadedDocuments || []
            if (ppoaDocs?.ppoa?.length > 0) {
                fields.PPOA = true
                let PPOAData = ppoaDocs?.ppoa?.filter(item => {
                    if (item?.ocrDetails?.address_pin) {
                        return item.ocrDetails
                    }
                })
                PPOAData?.length > 0 && getAllOCRDetails(PPOAData[0]?.ocrDetails || {}, 'ppoa')
            } else if (ppoaDocs?.ppoa?.length === 0 && stageStatus?.status == 0) {
                fields.PPOA = false
            }
            setShowFields({ ...fields })
        } else {
            setShowFields({ CPOA: false, PPOA: false, PPOAdisabled: false, CPOAdisabled: false })
        }
    }

    function resolveAddressDuplicate(address, duplicateCheck, isLine2) {
        const filteredAddressLine = address?.split(",")?.filter((d) => {
            return !duplicateCheck?.some(item => item?.replaceAll(/\s/g, '')?.toLowerCase() === d?.replaceAll(/\s/g, '')?.toLowerCase());
        });

        let arrLength = filteredAddressLine?.length;
        if (isLine2 === 1) {
            let res = filteredAddressLine?.splice(0, Math.ceil(filteredAddressLine?.length / 2));
            return res?.join()?.trim();
        } else if (isLine2 === 2) {
            let res = filteredAddressLine?.splice(Math.ceil(filteredAddressLine?.length / 2), arrLength);
            return res?.join()?.trim();
        }
        return filteredAddressLine?.join()?.trim();
    }

    const setFormValues = (values, type) => {
        const { address, address_care_of, address_line1, address_line2, address_state, address_city, address_district, address_pin, address_landmark } = values || {};
        let flatHouseNo = "";
        let colonyStreetLocality = "";
        let townArea = "";
        let landmark = "";
        if (address) {
            const addressParts = address.split(',').map(part => part.trim());
            let partCounter = 0;
            let splitCounter = 0;
            if (addressParts.length > 4) {
                splitCounter = 1;
            }
            if (parseInt(addressParts[partCounter])){
                flatHouseNo = `${addressParts[partCounter]?.replace(/\s+/g, ' ').trim()}, ${addressParts[partCounter+1]?.replace(/\s+/g, ' ').trim()}`; // First part
                partCounter+=2;
            }
            else{
                flatHouseNo = addressParts[partCounter]?.replace(/\s+/g, ' ').trim() || ""; // First part
                partCounter++;
            }
            colonyStreetLocality = addressParts[partCounter]?.replace(/\s+/g, ' ').trim() || ""; // Second part
            partCounter++;
            townArea = addressParts[partCounter]?.replace(/\s+/g, ' ').trim() || ""; // Third part
            partCounter++;
            landmark = addressParts.slice(partCounter).join(', ')?.replace(/\s+/g, ' ').trim() || ""; // Join remaining parts
        }
        let duplicateCheck = [
            ...(address_landmark ? [address_landmark.toLowerCase().trim()] : []),
            ...(address_care_of ? [address_care_of.toLowerCase().trim()] : []),
            ...(address_state ? [address_state.toLowerCase().trim()] : []),
            ...(address_city ? [address_city.toLowerCase().trim()] : []),
            ...(address_pin ? [address_pin.trim()] : []),
            ...(landmark ? [landmark.toLowerCase().trim()] : []),
        ];

        formik.setFieldValue(`${type}FlatHouseNo`, resolveAddressDuplicate(flatHouseNo, duplicateCheck) || "");
        formik.setFieldValue(`${type}ColonyStreetLocality`, resolveAddressDuplicate(colonyStreetLocality, duplicateCheck) || "");
        formik.setFieldValue(`${type}TownArea`, resolveAddressDuplicate(townArea, duplicateCheck) || "");
        formik.setFieldValue(`${type}Landmark`, resolveAddressDuplicate(landmark, duplicateCheck) || "");
        formik.setFieldValue(`${type}Pincode`, (address_pin)?.trim() || "");

        if (address_pin) {
            autoPincodeSearch((address_pin)?.trim(), type);
        }
    }

    const getAllOCRDetails = (values, type) => {
		if (type === 'cpoa') {
			setFormValues(values,'corr')
		} else if (type === 'ppoa') {
			setFormValues(values,'perm')
		}
	}

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    stageStatus = resp.data.success.stageDetilasList[0];
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if (detailChecker(resp.data.success.stageDetilasList, 0)) {
                        getAddressDetails()
                    }
                    else {
                        getKRADetails()
                    }
                    if (detailChecker(resp.data.success.stageDetilasList, 1)) {
                        getFATCADetails()
                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }


    const initialAddressDetailsValues = (values = kRAData, isEdited) => {
        // ["fName","mName","lName","faFName","fmFName","flFName","gender","marStatus","email","mobile","emailRelation","mobileRelation"]
        formik.setFieldValue("corrFlatHouseNo", values?.corrAddress1 || values?.corAddress1)
        formik.setFieldValue("corrColonyStreetLocality", values?.corrAddress2 || values?.corAddress2)
        formik.setFieldValue("corrTownArea", values?.corrAddress3 || values?.corAddress3)
        formik.setFieldValue("corrLandmark", values?.corrLandMark)
        formik.setFieldValue("corrPincode", values?.corrAddressPincode || values?.corPin)
        formik.setFieldValue("corrState", values?.corrAddressState || values?.corState)
        formik.setFieldValue("corrCity", values?.corrAddressCity || values?.corCity)
        !isEdited && formik.setFieldValue("sameAsCorrAddress", values?.sameAsCorrespondanceAddress || "")
        formik.setFieldValue("permFlatHouseNo", values?.permAddress1 || values?.perAddress1 || "")
        formik.setFieldValue("permColonyStreetLocality", values?.permAddress2 || values?.perAddress2 || "")
        formik.setFieldValue("permTownArea", values?.permAddress3 || values?.perAddress3 || "")
        formik.setFieldValue("permLandmark", values?.permLandMark || "")
        formik.setFieldValue("permPincode", values?.permAddressPinCode || values?.perPin || "")
        formik.setFieldValue("permState", values?.permAddressState || values?.perState || "")
        formik.setFieldValue("permCity", values?.permAddressCity || values?.perCity || "")
    }

    const initialFATCADetailsValues = (values = FATCAData) => {
        // ["fName","mName","lName","faFName","fmFName","flFName","gender","marStatus","email","mobile","emailRelation","mobileRelation"]
        formik.setFieldValue("annualIncomeRange", values.incomeSlabId)
        formik.setFieldValue("networth", values.networth )
        formik.setFieldValue("networthDate", values.networthDate|| getLastDateOfFinancialYear())
        formik.setFieldValue("occupation", values.occupationId)
        formik.setFieldValue("tradingExp", values.tradingExperience)
        formik.setFieldValue("politicalAffiliation", values.politicallyExpPerson)
        formik.setFieldValue("natureOfBusiness", values.natureOfBusinessId)
        formik.setFieldValue("natureOfBusinessOther", values.natureOfBusinessOther)
        formik.setFieldValue("sourceOfWealth", values.sourceOfWealth)
        formik.setFieldValue("placeOfBirth", values.placeOfBirth)
        formik.setFieldValue("countryOfBirth", values.countryOfBirth)
        formik.setFieldValue("fatcaDeclaration", values.isFatca)
        formik.setFieldValue("isAgreeMITC", values.isAgreeMITC)
        formik.setFieldValue("isDDPIConsent", values.isDDPIConsent)
        formik.setFieldValue("isMTFDeclaration", values.isMTFDeclaration)
        formik.setFieldValue("agreementOfConsents", values.isDeclared)
    }

    const getKRADetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getKRA).then(resp => {
            if (resp.data.success) {
                setKRAData(resp.data.success)
                if (resp.data.success.isKRAVerified) {
                    initialAddressDetailsValues(resp.data.success)
                    setShowFields({ CPOA: true, PPOA: true, CPOAdisabled: true, PPOAdisabled: true })
                } else {
                    setShowFields({ CPOA: false, PPOA: false, CPOAdisabled: true, PPOAdisabled: true })
                }
                setIsEdit(!resp.data.success.isKRAVerified)
                // setShowFields({CPOA:true, PPOA:true, CPOAdisabled:true, PPOAdisabled:true})
                dispatch(addStageData({ ...store, isKRAVerified: resp.data.success.isKRAVerified }))
                setLoading(false)
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }

    const getAddressDetails = (isEdited) => {
        axios.get(process.env.REACT_APP_API_URL + config.getAddressDetails).then(resp => {
            setLoading(false)
            if (resp.data.success) {
                initialAddressDetailsValues(resp.data.success[0], isEdited)
                setIsEdit(!resp.data.success[0].isKRAVerified)
                kraVerified=resp.data.success[0].isKRAVerified
                setShowFields({...showFields, CPOA:true, PPOA:true})
                dispatch(addStageData({ ...store, ...resp.data.success[0] }))
                setUploadedDocuments({...uploadedDocuments, cpoa:resp.data.success[0].kycFormProofUpload?.filter(item=>item.documentTypeCode === "CPOA"), ppoa:resp.data.success[0].kycFormProofUpload?.filter(item=>item.documentTypeCode === "PPOA")})
                setDocumentsUploadedDetails(resp.data.success[0].kycFormProofUpload.map(doc => { return { "documentOf": doc.documentTypeCode, "proofId": doc.kycstgProofId } }))
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }
    const getFATCAOptions = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getFATCAOptions)
            .then(resp => {
                if (resp.data.success) {
                    var optionsData = resp.data.success;
                    const othersList = [{
                        "id": 5,
                        "natureOfBusinessDesc": "Others",
                        "isActive": true
                    }];
                    const natureOfBusinessAllList = [
                        {
                            "id": 1,
                            "natureOfBusinessDesc": "Manufacturing",
                            "isActive": true
                        },
                        {
                            "id": 2,
                            "natureOfBusinessDesc": "Services",
                            "isActive": true
                        },
                        {
                            "id": 3,
                            "natureOfBusinessDesc": "Trading",
                            "isActive": true
                        },
                        {
                            "id": 4,
                            "natureOfBusinessDesc": "Consultancy",
                            "isActive": true
                        },
                        {
                            "id": 5,
                            "natureOfBusinessDesc": "Others",
                            "isActive": true
                        }
                    ]
                    optionsData.occupationList?.map(occupation =>{
                        if(occupation.selectValue == "5-Private Sector"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "6-Public Sector"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "7-Govt. service"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "8-Professional"){
                            occupation["natureOfBusinessList"] = [{
                                "id": 2,
                                "natureOfBusinessDesc": "Services",
                                "isActive": true
                            }]
                        }
                        else if(occupation.selectValue == "9-Self Employed"){
                            occupation["natureOfBusinessList"] = natureOfBusinessAllList
                            occupation["isOtherAllowed"] = true
                        }
                        else if(occupation.selectValue == "10-Retired"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "11-Housewife"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "11-Housewife"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "12-Student"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "13-Business"){
                            occupation["natureOfBusinessList"] = natureOfBusinessAllList
                            occupation["isOtherAllowed"] = true
                        }
                    })
                    setOptions(resp.data.success)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }

    const getFATCADetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getFATCADetails)
            .then(resp => {
                if (resp.data.success) {
                    initialFATCADetailsValues(resp.data.success[0])
                    setFATCAData(resp.data.success[0])
                    setLoading(false)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const incomeNetWorthMapping = {
        1: { minNetWorth: 100000, maxNetWorth: 1000000, errorMessage: localeText.AddressNetWorthInvalid1, suggestionText: localeText.netWorthSuggestionText1 }, // 1-10 Lac
        2: { minNetWorth: 1000000, maxNetWorth: 5000000, errorMessage: localeText.AddressNetWorthInvalid2, suggestionText: localeText.netWorthSuggestionText2 }, // 10-50 Lacs
        3: { minNetWorth: 5000000, maxNetWorth: 10000000, errorMessage: localeText.AddressNetWorthInvalid3, suggestionText: localeText.netWorthSuggestionText3 }, // 50 Lacs-1 Crore
        4: { minNetWorth: 10000000, maxNetWorth: 25000000, errorMessage: localeText.AddressNetWorthInvalid4, suggestionText: localeText.netWorthSuggestionText4 }, // 1-2.5 Crore
        5: { minNetWorth: 25000000, maxNetWorth: 500000000, errorMessage: localeText.AddressNetWorthInvalid5, suggestionText: localeText.netWorthSuggestionText5 }, // 2.5-50 Crore
    };

    const handleAnnualIncomeRange = (e) => {
        formik.setFieldValue("annualIncomeRange", e.target.value)
        if (e.target.value === 1) {
            formik.setFieldValue("networth", 100000)
        } else if (e.target.value === 2) {
            formik.setFieldValue("networth", 1000000)
        } else if (e.target.value === 3) {
            formik.setFieldValue("networth", 5000000)
        } else if (e.target.value === 4) {
            formik.setFieldValue("networth", 10000000)
        } else if (e.target.value === 5) {
            formik.setFieldValue("networth", 25000000)
        } else {
            formik.setFieldValue("networth", "")
        }
    }

    const validationSchema = yup.object({
        corrFlatHouseNo: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidFlatNo)
            .required(localeText?.AddressCorrespondenceFlatNo)
            .max(100, 'Max 100 characters allowed'),
        corrColonyStreetLocality: yup
            .string('').required(localeText?.AddressCorrespondenceColony)
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidColony)
            .max(100, 'Max 100 characters allowed'),
        corrTownArea: yup
            .string('')
            .nullable()
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidTown)
            .required(localeText?.AddressCorrespondenceTown)
            .max(100, 'Max 100 characters allowed'),
        corrLandmark: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidLandmark)
            .max(100, 'Max 100 characters allowed'),
        corrPincode: yup
            .string('')
            .required(localeText?.AddressCorrespondencePincode),
        corrState: yup
            .string('')
            .required(localeText?.AddressCorrespondenceState),
        corrCity: yup
            .string('')
            .required(localeText?.AddressCorrespondenceCity),
        // sameAsCorrAddress: yup
        //     .boolean(''),
        permFlatHouseNo: yup
            .string('')
            .required(localeText?.AddressPermanentFlatNo)
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidFlatNo)
            .max(100, 'Max 100 characters allowed'),
        permColonyStreetLocality: yup
            .string('')
            .required(localeText?.AddressPermanentColony)
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidColony)
            .max(100, 'Max 100 characters allowed'),
        permTownArea: yup
            .string('')
            .nullable()
            .required(localeText?.AddressPermanentTown)
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidTown)
            .max(100, 'Max 100 characters allowed'),
        permLandmark: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-:\/]+(?: [a-zA-Z\d',.#&-:\/]+)*$/, localeText?.AddressValidLandmark)
            .max(100, 'Max 100 characters allowed'),
        permPincode: yup
            .string('')
            .required(localeText?.AddressPermanentPincode),
        permState: yup
            .string('')
            .required(localeText?.AddressPermanentState),
        permCity: yup
            .string('')
            .required(localeText?.AddressPermanentCity),
        annualIncomeRange: yup
            .string('')
            .required(localeText?.AddressAnnualIncome),
        networth: yup
            .number()
            .required(localeText.AddressNetWorthRequired)
            .test('is-valid-net-worth', function (value) {
                const { annualIncomeRange } = this.parent;
                const incomeRange = incomeNetWorthMapping[annualIncomeRange];

                if (!incomeRange) return true;

                const minNetWorth = incomeRange.minNetWorth;
                const maxNetWorth = incomeRange.maxNetWorth;

                const isValid = value >= minNetWorth && value <= maxNetWorth;
                return isValid || this.createError({ message: incomeRange.errorMessage });
        }),
        networthDate: yup
            .number()
            .required(localeText?.AddressNetWorthAsOnDateRequired),
        occupation: yup
            .string('')
            .required(localeText?.AddressOccupation),
        tradingExp: yup
            .number('')
            .max(99, localeText?.AddressTradingExperience).min(0, localeText?.AddressTradingExperience)
            .typeError(localeText?.loginInvalidNo),
        politicalAffiliation: yup
            .string('')
            .required(localeText?.AddressPolitical),
        natureOfBusiness: yup
            .string('')
            .required(localeText?.AddressNature),
        natureOfBusinessOther: yup
            .string('')
            .when('natureOfBusiness', {
                is: "5",
                then: yup.string('')
                    .required(localeText?.AddressOtherNature),
                otherwise: yup.string('')
            }),
        sourceOfWealth: yup
            .string('')
            .required(localeText?.AddressSourceWealth),
        placeOfBirth: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-\/]+(?: [a-zA-Z\d',.#&-\/]+)*$/, localeText?.AddressValidPlace)
            .required(localeText?.AddressPlaceBirth),
        countryOfBirth: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-\/]+(?: [a-zA-Z\d',.#&-\/]+)*$/, localeText?.AddressValidCountry)
            .required(localeText?.AddressCountryBirth),
        // fatcaDeclaration: yup
        //     .boolean(''),
        // agreementOfConsents: yup
        //     .boolean('')
    });

    const nextNavigation = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
            navigate("/NomineeDetails")
        }
    }
    
    const submitFATCADetails = (values) => {
        let dataObj = {}
        dataObj.kycIncomeSlab = Number(values.annualIncomeRange)
        dataObj.networth = Number(values.networth)
        dataObj.networthDate = Number(values.networthDate)
        dataObj.kycNatureOfBusiness = Number(values.natureOfBusiness)
        dataObj.kycOccupation = Number(values.occupation)
        dataObj.annualIncomeDelDate = ""
        dataObj.occupationOther = ""
        dataObj.politicallyExpPerson = values.politicalAffiliation
        dataObj.tradingExperience = values.tradingExp || "0"
        dataObj.isFatca = values.fatcaDeclaration
        dataObj.isAgreeMITC=values.isAgreeMITC
        dataObj.isDDPIConsent=values.isDDPIConsent
        dataObj.isMTFDeclaration=values.isMTFDeclaration
        dataObj.isDeclared = values.agreementOfConsents
        dataObj.addressType = ""
        dataObj.placeOfBirth = values.placeOfBirth
        dataObj.countryOfBirth = values.countryOfBirth
        dataObj.sourceOfWealth = Number(values.sourceOfWealth)
        dataObj.taxStatus = ""
        dataObj.natureOfBusinessOther = values.natureOfBusinessOther || ""
        dataObj.consent = checkedField
        axios.post(process.env.REACT_APP_API_URL + config.FATCADetails, dataObj)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    dispatch(addStageData({ ...store, addressFatcaDetails: values }))
                    dispatch(updateStepper({ step: 2, nestedStep: 2 }));
                    nextNavigation()
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })

    }

    const submitAddressDetails = (values) => {
        setLoading(true)
        let objData = {}
        objData.loginId = "123"
        objData.permAddress1 = objData.corrAddress1 = values.corrFlatHouseNo || ""
        objData.permAddress2 = objData.corrAddress2 = values.corrColonyStreetLocality || ""
        objData.permAddress3 = objData.corrAddress3 = values.corrTownArea || ""
        objData.permLandMark = objData.corrLandMark = values.corrLandmark || ""
        objData.permAddressPinCode = objData.corrAddressPincode = values.corrPincode || ""
        objData.permAddressCity = objData.corrAddressCity = values.corrCity || ""
        objData.permAddressState = objData.corrAddressState = values.corrState || ""
        objData.permAddressCountry = objData.corrAddressCountry = "India"
        objData.sameAsCorrespondanceAddress = !!values.sameAsCorrAddress
        if (!values.sameAsCorrAddress) {
            objData.permAddress1 = values.permFlatHouseNo || ""
            objData.permAddress2 = values.permColonyStreetLocality || ""
            objData.permAddress3 = values.permTownArea || ""
            objData.permLandMark = values.permLandmark || ""
            objData.permAddressPinCode = values.permPincode || ""
            objData.permAddressCity = values.permCity || ""
            objData.permAddressState = values.permState || ""
        }
        objData.isAddChange = isEdit
        objData.isKRACorrespondanceAddChange = isEdit
        objData.isKRAPermanantAddChange = isEdit
        axios.post(process.env.REACT_APP_API_URL + config.addressDetails, objData)
            .then(resp => {
                if (resp.data.success) {
                    submitFATCADetails(values)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleSubmit = (values) => {
        console.log(uploadedDocuments, 'uploadedDocuments')
        if (isEdit && (Object.keys(uploadedDocuments).length == 0 ||
            (values.sameAsCorrAddress && !Object.keys(uploadedDocuments).length) ||
            (!values.sameAsCorrAddress && !uploadedDocuments.ppoa.find(doc => doc.documentTypeCode == 'PPOA')))) {
            setResponseStatus({ "message": localeText?.AddressMandatory, "type": "error" })
            setSnackBarOpen(true)
            return
        }

        submitAddressDetails(values)
    }

    const formik = useFormik({
        initialValues: {
            corrFlatHouseNo: '',
            corrColonyStreetLocality: "",
            corrTownArea: "",
            corrLandmark: "",
            corrPincode: "",
            corrState: "",
            corrCity: "",
            sameAsCorrAddress: false,
            permFlatHouseNo: "",
            permColonyStreetLocality: "",
            permTownArea: "",
            permLandmark: "",
            permPincode: "",
            permState: "",
            permCity: "",

            annualIncomeRange: "",
            networth:"",
            networthDate:getLastDateOfFinancialYear(),
            occupation: "",
            tradingExp: "",
            politicalAffiliation: "",
            natureOfBusiness: "",
            natureOfBusinessOther: "",
            sourceOfWealth: "",
            placeOfBirth: "",
            countryOfBirth: "",
            fatcaDeclaration: false,
            isAgreeMITC:false,
            isDDPIConsent:false,
            isMTFDeclaration:false,
            agreementOfConsents: false,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values)
        },
    });

    const handleSameAsCorrAddress = (e) => {
        let value = e.target.checked;
        console.log(e.target.checked, 'checked')
        if (value) {
            formik.setFieldValue("permFlatHouseNo", formik.values.corrFlatHouseNo)
            formik.setFieldValue("permColonyStreetLocality", formik.values.corrColonyStreetLocality)
            formik.setFieldValue("permTownArea", formik.values.corrTownArea)
            formik.setFieldValue("permLandmark", formik.values.corrLandmark)
            formik.setFieldValue("permPincode", formik.values.corrPincode)
            formik.setFieldValue("permState", formik.values.corrState)
            formik.setFieldValue("permCity", formik.values.corrCity)
        }else {
            formik.setFieldValue("permFlatHouseNo", "")
            formik.setFieldValue("permColonyStreetLocality", "")
            formik.setFieldValue("permTownArea", "")
            formik.setFieldValue("permLandmark", "")
            formik.setFieldValue("permPincode", "")
            formik.setFieldValue("permState", "")
            formik.setFieldValue("permCity", "")
            // initialAddressDetailsValues(null, true)
        }
    }

    const setPincodeSearchFields = (searchedItem, addressType) => {
        if (addressType == "corr") {
            formik.setFieldValue("corrPincode", searchedItem.pinCode)
            formik.setFieldValue("corrState", searchedItem.state)
            formik.setFieldValue("corrCity", searchedItem.city)
        }
        if (addressType == "perm" || formik.values.sameAsCorrAddress) {
            formik.setFieldValue("permPincode", searchedItem.pinCode)
            formik.setFieldValue("permState", searchedItem.state)
            formik.setFieldValue("permCity", searchedItem.city)
        }
        setOpen({ ...open, [addressType]: false })
        setPincodeOptions([])
    }


    const autoPincodeSearch = (value, type) =>{
            if (value.length > 2 ) {
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    setPincodeOptions([])
                    let dataObj = {
                        key: value,
                        type: "pinCode"
                    }
                    axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                        .then(resp => {
                            if (resp.data.success) {
                                setPincodeOptions(resp.data.success)
                                setPincodeSearchFields(resp.data.success[0], type)
                            }
                            else {
                                throw new Error(resp.data.error)
                            }
                        }).catch((error) => {
                            setResponseStatus({ "message": error.message, "type": "error" })
                            setSnackBarOpen(true)
                        })
                }, 1000)
            }
    }

    let timer;
    const handlePincodeSearch = (e) => {
        if (e.target.value.length > 2 || e.length > 2 ) {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                setPincodeOptions([])
                let dataObj = {
                    key: e.target.value,
                    type: "pinCode"
                }
                axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                    .then(resp => {
                        if (resp.data.success) {
                            setPincodeOptions(resp.data.success)
                        }
                        else {
                            throw new Error(resp.data.error)
                        }
                    }).catch((error) => {
                        setResponseStatus({ "message": error.message, "type": "error" })
                        setSnackBarOpen(true)
                    })
            }, 1000)
        }
    }

    const getOptionComponent = (searchedItem, addressType) => {
        return <Grid item css={{ width: "100%", padding: "20px", borderTop: "1px solid grey", cursor: "pointer" }} onClick={() => setPincodeSearchFields(searchedItem, addressType)}>
            <Typography variant='body1' css={{ fontWeight: "bold" }}>
                {localeText?.AddressPinCode + searchedItem.pinCode}
            </Typography>
            <Typography variant='body2'>
                {localeText?.AddressState + searchedItem.state}
            </Typography>
            <Typography variant='body2'>
                {localeText?.AddressCity + searchedItem.city}
            </Typography>
        </Grid>
    }

    const handleSameAsCorrespondenceChecked = (e, fieldName) => {
        if (formik.values.sameAsCorrAddress) {
            formik.setFieldValue(fieldName, e.currentTarget.value)
        }
    }

    function toogleInnerDialog() {
        setOpenInnerDialog(!openInnerDialog);
    }

    var getDocumentTypeOptions = (documentTypeCode, documentUploadedForValue, documentOfValue, screenOf) => {
        setDocumentTypeOption(documentTypeCode)
        setOpenInnerDialog(!openInnerDialog)
        setDocumentUploadedFor(documentUploadedForValue)
        setDocumentOf(documentOfValue)
        setDocumentOfScreen(screenOf)
    }

    const onFile = (prm, docId, count, name, mappingKey) => {
        prm.then(succ => {
            toogleInnerDialog()
            if (succ.type.includes("pdf")) {
                setPdf(succ)
                setPdfPopup(true)
            }
            else {
                setImage([succ.data])
                setUploadPopup(true)
            }
            setDocMId(docId)
            setNumberOfImages(count)
            setDocumentName(name)
            setDocumentMappingKey(mappingKey)
        })
    }

    var uploadDocument = (documentData) => {
        setLoading(true)
        let documentArr = [...documentsUploadedDetails];
        let count = 0;
        documentData.forEach(document => {
            axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, document)
                .then(response => {
                    count++;
                    setLoading(false)
                    if (response?.data?.success) {
                        var docNotUploaded = response?.data?.success.find(docResponse => docResponse.Status == false)
                        if (docNotUploaded) {
                            setResponseStatus({ "message": `${localeText?.AddressUpload}${docNotUploaded.uploadId}`, "type": "error" })
                            setSnackBarOpen(true)

                        }
                        else {
                            if (documentTypeOption.toLowerCase().includes("nom")) {
                                // store.dispatch(change("nomineeDetails", "nomineeIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "nomineeIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            else if (documentTypeOption.toLowerCase().includes("gurd")) {
                                // store.dispatch(change("nomineeDetails", "guardianIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "guardianIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            setResponseStatus({ "message": localeText?.AddressSuccessfully, "type": "success" })
                            setSnackBarOpen(true)
                            documentArr = [...documentArr, {
                                "documentTypeCode": document.docTypeCode,
                                "proofId": response.data.success[0].id,
                                "documentOf": documentOf,
                                "documentScreen": documentOfScreen
                            }]
                            count == documentData.length && setDocumentsUploadedDetails(documentArr)
                        }
                    }
                    if (response.data.error) {
                        setResponseStatus({ "message": response.data.error, "type": "error" })
                        setSnackBarOpen(true)
                    }
                })
                .catch(exception => {
                    setLoading(false)
                    setResponseStatus({ "message": exception.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        })
    }

    const uploadImageProof = (data) => {
        if (data && data.length > 0) {
            var outData = data.map((dt, i) => dt && ({
                "pageNo": (i + 1),
                "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
                "uploadId": (i + 1),
                "docTypeCode": documentTypeOption,
                "docMId": docMId,
                "type": documentUploadedFor,
                // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
                // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
                "objectionId": "",
                "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
                "product": "diy",
                "base64Format": dt.split(",")[1],
                "isOcrRequired": true
            }))
            uploadDocument(outData)
        }
        setUploadPopup(false)

    }

    const uploadPdfProof = (pdfData, pdfName) => {
        setPdfPopup(false)
        var outData = [{
            "pageNo": "1",
            "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
            "uploadId": "1",
            "docTypeCode": documentTypeOption,
            "docMId": docMId,
            "type": documentUploadedFor,
            // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
            // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
            "objectionId": "",
            "fileType": "pdf",
            "product": "diy",
            "base64Format": pdfData && pdfData.split(",")[1],
            "isOcrRequired": true
        }]
        if (pdfData !== null) {
            uploadDocument(outData)
        }
    }

    const toggleKRAVerifiedDataEdittingPopup = () => {
        setOpenKRAVerifiedDataPopup(!openKRAVerifiedDataPopup)
    }

    const handleEditClick = () => {
        formik.setFieldValue("sameAsCorrAddress", false)
        if (kRAData?.isKRAVerified || kraVerified) {
            toggleKRAVerifiedDataEdittingPopup()
        }
        else {
            toggleEdit()
        }
    }

    const toggleEdit = () => {
        setIsEdit(!isEdit)
        if (isEdit) {

        } else {
            setShowFields({ ...showFields, CPOA: false, PPOA: false })
        }
    }

    const handleTermsAndConditions = () =>{
        setLoading(true)
        axios.get(process.env.REACT_APP_STRAPI_URL + config.customerHandout).then(resp => {
          if (resp && resp[0]?.fileUrl) {
            setLoading(false)
            window.open(process.env.REACT_APP_STRAPI_URL + resp[0]?.fileUrl, "_blank")
          }
        }).catch(exception => {
            setLoading(false)
          console.log(exception.msg)
        });
      }


    const handleMitcConsentClose = () => {
        setMitcConsentOpen(false);
      };


    const handleMtfConsentClose = () => {
        setMtfConsentOpen(false);
      };


    const handleDdpiConsentClose = () => {
        setDdpiConsentOpen(false);
        setisDdpiCheckedField(initialDdpiConsentCheckBox)
      };



    const onConsentChange = (key, value) => {
        if(key == "pastAction" && !value){
            setCheckedField({
                ...checkedField,
                "pastActionReason": "",
                [key]: value
            });
        }
        else{
            setCheckedField({
                ...checkedField,
                [key]: value
            });
        }
    };

    const onDdpiConsentChange = (key, value) => {
            setisDdpiCheckedField({
                ...isDdpiCheckedField,
                [key]: value
            });
    };

    const handleConsentClose = () => {
        setConsentOpen(false);
        var tempInitialConsentCheckBox = initialConsentCheckBox;
        tempInitialConsentCheckBox["authRunningAccount"] = checkedField?.authRunningAccount
        setCheckedField(tempInitialConsentCheckBox)
    };

    const handleAgreementOfConsents = (e, type) => {
        if (type === 'consent') {
            formik.setFieldValue("agreementOfConsents", e.currentTarget.checked)
            e.currentTarget.checked&& setConsentOpen(true);
        } else if (type === "mitcConsent") {
            formik.setFieldValue("isAgreeMITC", e.currentTarget.checked)
            e.currentTarget.checked&& setMitcConsentOpen(true);
        } else if (type === "ddpiConsent") {
            formik.setFieldValue("isDDPIConsent", e.currentTarget.checked)
            e.currentTarget.checked&& setDdpiConsentOpen(true);
        } else if (type === "mtfConsent") {
            formik.setFieldValue("isMTFDeclaration", e.currentTarget.checked)
            e.currentTarget.checked&& setMtfConsentOpen(true);
        }
    }

    const changeNatureOfBusinessOthers=(e, dependentChange)=>{
        var otherData = options?.occupationList.find(occupation=> occupation.id == (dependentChange ? e.target.value : formik.values.occupation));
        formik.setFieldValue("natureOfBusinessOther", ((dependentChange ? formik.values.natureOfBusiness == 5 : e.target.value == 5) && !otherData?.isOtherAllowed) ?  otherData?.occupationName : "")
    }

    return (
        <>
            <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                <PageLayout css={{ overflowY: "scroll" }} showSidebar isObjectionScreen={objectionState.isObjection}
                    breadcrumb={{ show: true, steps: steps[1].nestedSteps, step: 2, nestedStep: 2 }}>
                    <ElevatedGrid >
                        <Grid container item alignItems={"center"} spacing={3}>
                            <Grid container item alignItems={"center"}>
                                {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                    {objectionState.objections.map((objection, i) =>
                                        <>
                                            <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                                {localeText?.profileObjection} {objection.objectionDescription || "--"} | {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                            </Typography>
                                            {i > 0 && <Divider />}
                                        </>
                                    )}
                                </Grid>}
                                <Grid item xs={12}>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.Address}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{width:"100%"}}>
                                    <Typography display="inline" fontSize={"16px"} fontWeight={"bold"} color="black">
                                        {localeText?.AddressGuidelines} :
                                    </Typography>
                                    <List sx={{listStyle: "decimal", marginX: '20px', padding: 0, marginY: 0 }}>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                            {localeText?.AddressGuideline1}
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                            {localeText?.AddressGuideline2}
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                            {localeText?.AddressGuideline3}
                                        </ListItem>
                                    </List>
                                </Grid>
                                {!!store.isKRAVerified && <Grid item css={{ marginLeft: "auto" }}>
                                    {isEdit ? <img src="images/icon_close_black.svg" alt="edit" css={{ cursor: "pointer" }} onClick={() => { /* formik.resetForm(); */ initialAddressDetailsValues(); setIsEdit(!isEdit); setShowFields({ ...showFields, CPOA: true, PPOA: true }) }} /> : <img src="images/edit.svg" alt="edit" css={{ cursor: "pointer" }} onClick={()=>handleEditClick()} />}
                                </Grid>}
                            </Grid>

                            <Grid container item xs={12} xl={6} lg={12} md={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold" }}>
                                    {localeText?.AddressCorrespondence}
                                </Grid>
                                {
                                    (showFields?.CPOA) &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrFlatHouseNo" name="corrFlatHouseNo" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.corrFlatHouseNo)?.toUpperCase()}
                                                inputProps={{ maxLength: 50 }}
                                                error={formik.touched.corrFlatHouseNo && Boolean(formik.errors.corrFlatHouseNo)}
                                                helperText={formik.touched.corrFlatHouseNo && formik.errors.corrFlatHouseNo} fullWidth
                                                label={localeText?.AddressFlatNo} variant="outlined"
                                                disabled={!isEdit /* || showFields?.CPOAdisabled */}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permFlatHouseNo"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrColonyStreetLocality" name="corrColonyStreetLocality" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={formik.values.corrColonyStreetLocality}
                                                error={formik.touched.corrColonyStreetLocality && Boolean(formik.errors.corrColonyStreetLocality)}
                                                helperText={formik.touched.corrColonyStreetLocality && formik.errors.corrColonyStreetLocality} fullWidth
                                                label={localeText?.AddressColony} variant="outlined"
                                                disabled={!isEdit /* || showFields?.CPOAdisabled */}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permColonyStreetLocality"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrTownArea" name="corrTownArea" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.corrTownArea)?.toUpperCase()}
                                                error={formik.touched.corrTownArea && Boolean(formik.errors.corrTownArea)}
                                                helperText={formik.touched.corrTownArea && formik.errors.corrTownArea} fullWidth
                                                label={localeText?.AddressTownArea} variant="outlined"
                                                disabled={!isEdit /* || showFields?.CPOAdisabled */}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permTownArea"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrLandmark" name="corrLandmark" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.corrLandmark)?.toUpperCase()}
                                                error={formik.touched.corrLandmark && Boolean(formik.errors.corrLandmark)}
                                                helperText={formik.touched.corrLandmark && formik.errors.corrLandmark} fullWidth
                                                label={localeText?.AddressLandmark} variant="outlined"
                                                disabled={!isEdit /* || showFields?.CPOAdisabled */}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permLandmark"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                css={{ marginTop: "10px" }}
                                                id="corrPincode" name="corrPincode"
                                                value={formik.values.corrPincode}
                                                open={open?.corr}
                                                onOpen={() => {
                                                    setOpen({ ...open, corr: true });
                                                }}
                                                onClose={() => {
                                                    setOpen({ ...open, corr: false });
                                                }}
                                                disabled={!isEdit /* || showFields?.CPOAdisabled */}
                                                options={pincodeOptions}
                                                disablePortal
                                                filterOptions={(x) => x}
                                                loading={open?.corr && pincodeOptions.length == 0}
                                                renderOption={(props, searchedItem, state) => {
                                                    return getOptionComponent(searchedItem, "corr")
                                                }}
                                                isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                                                getOptionLabel={(option) => { return option }}
                                                renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.AddressPinC}
                                                    onChange={e => handlePincodeSearch(e, "corr")}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    required
                                                    size="small"
                                                    id="corrPincode" name="corrPincode"
                                                    error={formik.touched.corrPincode && Boolean(formik.errors.corrPincode)}
                                                    helperText={formik.touched.corrPincode && formik.errors.corrPincode}
                                                />}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="corrState" name="corrState" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.corrState)?.toUpperCase()}
                                                error={formik.touched.corrState && Boolean(formik.errors.corrState)}
                                                helperText={formik.touched.corrState && formik.errors.corrState} fullWidth
                                                label={localeText?.AddressS} variant="outlined"
                                                disabled
                                                required
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permState"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="corrCity" name="corrCity" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.corrCity)?.toUpperCase()}
                                                error={formik.touched.corrCity && Boolean(formik.errors.corrCity)}
                                                helperText={formik.touched.corrCity && formik.errors.corrCity} fullWidth
                                                label={localeText?.AddressC} variant="outlined"
                                                disabled
                                                required
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permCity"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                    </>
                                }
                                {isEdit && <Grid item xs={12} >
                                    {/* <UploadIcon
                                        isSVG={true}
                                        uploadDocument={() => getDocumentTypeOptions("CPOA", "holder1", "CPOA", "")}
                                        required={true}
                                        uploaded={documentsUploadedDetails.find(holder => holder.documentOf == "CPOA" ? true : false)}
                                        loading={false}
                                        image={documentICONS["CPOA"]}
                                        pgloading={false}
                                        loader={null}
                                    >
                                        {localeText?.AddressProof}
                                    </UploadIcon> */}
                                    <Upload
                                        masterId={'3'}
                                        title={localeText?.AddressProof}
                                        documentOptionData={{ id: "CPOA", type: "holder1", code: "CPOA", screen: "" }}
                                        setUploadedDocuments={(data) => {
                                            setUploadedDocuments({ ...uploadedDocuments, cpoa: data })
                                        }}
                                        uploadedDocuments={uploadedDocuments?.cpoa}
                                        isRequired={true}
                                        setOcrUploadLoading={setOcrUploadLoading}
                                        ocrUploadLoading={ocrUploadLoading}
                                        limitPdfPages={1}
                                        getAllAdressData={getAllAdressData}
                                        isAddressDetails={true}
                                    />
                                </Grid>}
                            </Grid>

                            <Grid container item xs={12} xl={6} lg={12} md={12} spacing="12" css={{ marginTop: "5px", alignSelf: "flex-start" }}>
                                <Grid container item xs={12} css={{ fontWeight: "bold", marginRight: "10px" }}>
                                    <Grid item css={{ fontWeight: "bold" }}>
                                        <Typography display="inline" fontWeight={"bold"}>
                                            {localeText?.AddressPermanent}
                                        </Typography>
                                    </Grid>
                                    <Grid item css={{ marginLeft: "10px" }}>
                                        <FormControl disabled={!isEdit || !showFields?.CPOA}>
                                            <FormControlLabel control={<Checkbox css={{ padding: 0, marginRight: "5px", marginLeft: "10px" }} name="sameAsCorrAddress" id="sameAsCorrAddress" checked={formik.values.sameAsCorrAddress} onChange={e => { handleSameAsCorrAddress(e); formik.setFieldValue("sameAsCorrAddress", e.currentTarget.checked) }} />}
                                                label={<Typography variant='body2'>
                                                    {localeText?.AddressSameAs}
                                                </Typography>}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {
                                    (showFields?.PPOA || formik.values.sameAsCorrAddress) &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permFlatHouseNo" name="permFlatHouseNo" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permFlatHouseNo)?.toUpperCase()}
                                                error={formik.touched.permFlatHouseNo && Boolean(formik.errors.permFlatHouseNo)}
                                                helperText={formik.touched.permFlatHouseNo && formik.errors.permFlatHouseNo} fullWidth
                                                label={localeText?.AddressFlatNo} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={formik.values.sameAsCorrAddress || (!isEdit /* || showFields?.PPOAdisabled */)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permColonyStreetLocality" name="permColonyStreetLocality" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permColonyStreetLocality)?.toUpperCase()}
                                                error={formik.touched.permColonyStreetLocality && Boolean(formik.errors.permColonyStreetLocality)}
                                                helperText={formik.touched.permColonyStreetLocality && formik.errors.permColonyStreetLocality} fullWidth
                                                label={localeText?.AddressColony} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={formik.values.sameAsCorrAddress || (!isEdit /* || showFields?.PPOAdisabled */)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permTownArea" name="permTownArea" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permTownArea)?.toUpperCase()}
                                                error={formik.touched.permTownArea && Boolean(formik.errors.permTownArea)}
                                                helperText={formik.touched.permTownArea && formik.errors.permTownArea} fullWidth
                                                label={localeText?.AddressTownArea} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={formik.values.sameAsCorrAddress || (!isEdit /* || showFields?.PPOAdisabled */)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permLandmark" name="permLandmark" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.permLandmark)?.toUpperCase()}
                                                error={formik.touched.permLandmark && Boolean(formik.errors.permLandmark)}
                                                helperText={formik.touched.permLandmark && formik.errors.permLandmark} fullWidth
                                                label={localeText?.AddressLandmark} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={formik.values.sameAsCorrAddress || (!isEdit /* || showFields?.PPOAdisabled */)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                css={{ marginTop: "10px" }}
                                                id="permPincode" name="permPincode"
                                                value={formik.values.permPincode}
                                                open={open?.perm}
                                                onOpen={() => {
                                                    setOpen({ ...open, perm: true });
                                                }}
                                                onClose={() => {
                                                    setOpen({ ...open, perm: false });
                                                }}
                                                disabled={formik.values.sameAsCorrAddress || !isEdit}
                                                options={pincodeOptions}
                                                disablePortal
                                                filterOptions={(x) => x}
                                                loading={open?.perm && pincodeOptions.length == 0}
                                                renderOption={(props, searchedItem, state) => {
                                                    return getOptionComponent(searchedItem, "perm")
                                                }}
                                                isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                                                getOptionLabel={(option) => { return option }}
                                                renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.AddressPinC}
                                                    onChange={e => handlePincodeSearch(e, "perm")}
                                                    id="permPincode" name="permPincode"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    required
                                                    size="small"
                                                    error={formik.touched.permPincode && Boolean(formik.errors.permPincode)}
                                                    helperText={formik.touched.permPincode && formik.errors.permPincode}
                                                />}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="permState" name="permState" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.permState)?.toUpperCase()}
                                                error={formik.touched.permState && Boolean(formik.errors.permState)}
                                                helperText={formik.touched.permState && formik.errors.permState} fullWidth
                                                label={localeText?.AddressS} variant="outlined"
                                                disabled
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="permCity" name="permCity" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.permCity)?.toUpperCase()}
                                                error={formik.touched.permCity && Boolean(formik.errors.permCity)}
                                                helperText={formik.touched.permCity && formik.errors.permCity} fullWidth
                                                label={localeText?.AddressC} variant="outlined"
                                                disabled
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                    </>
                                }
                                {(isEdit && !formik.values.sameAsCorrAddress) && <Grid item xs={12}>
                                    {/* <UploadIcon
                                        isSVG={true}
                                        uploadDocument={() => getDocumentTypeOptions("PPOA", "holder1", "PPOA", "")}
                                        required={!formik.values.sameAsCorrAddress}
                                        uploaded={documentsUploadedDetails.find(holder => holder.documentOf == "PPOA" ? true : false)}
                                        loading={false}
                                        image={documentICONS["PPOA"]}
                                        pgloading={false}
                                        loader={null}
                                        disableCursorForUploaded={formik.values.sameAsCorrAddress}
                                    >
                                        {localeText?.AddressProof}
                                    </UploadIcon> */}
                                    <Upload
                                        masterId={'2'}
                                        title={localeText?.AddressProof}
                                        documentOptionData={{ id: "PPOA", type: "holder1", code: "PPOA", screen: "" }}
                                        setUploadedDocuments={(data) => {
                                            setUploadedDocuments({ ...uploadedDocuments, ppoa: data })
                                        }}
                                        uploadedDocuments={uploadedDocuments?.ppoa}
                                        isRequired={true}
                                        setOcrUploadLoading={setOcrUploadLoading}
                                        ocrUploadLoading={ocrUploadLoading}
                                        limitPdfPages={1}
                                        getAllAdressData={getAllAdressData}
                                        isAddressDetails={true}
                                    />
                                </Grid>}
                            </Grid>

                            <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center", paddingBottom: "20px" }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center", paddingBottom: "20px" }}>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.AddressFatca}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.annualIncomeRange && Boolean(formik.errors.annualIncomeRange)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectAnnual}
                                        </InputLabel>
                                        <Select
                                            id="annualIncomeRange"
                                            name="annualIncomeRange"
                                            value={formik.values.annualIncomeRange}
                                            onChange={e => handleAnnualIncomeRange(e)}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectAnnual}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.annualIncomeSlabList?.map(opt => <MenuItem value={opt.id}>{opt.slabRange}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.annualIncomeRange && formik.errors.annualIncomeRange}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="networth" name="networth" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        // inputProps={{ maxLength: 2 }}
                                        value={formik.values.networth}
                                        error={formik.touched.networth && Boolean(formik.errors.networth)}
                                        helperText={formik.touched.networth && formik.errors.networth} fullWidth
                                        label={localeText?.AddressNetWorth} variant="outlined"
                                        onChange={formik.handleChange}  
                                    />
                                    {formik.values.networth && (
                                        <div style={{ color: 'gray', marginTop: '5px' }}>
                                            {incomeNetWorthMapping[formik.values.annualIncomeRange]?.suggestionText}
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            css={{ width: "100%", marginTop: "10px" }}
                                            inputFormat="DD/MM/YYYY"
                                            id="networthDate"
                                            views={['year', 'month', 'day']}
                                            name="networthDate"
                                            value={getLastDateOfFinancialYear()}
                                            label={localeText?.AddressNetWorthAsOnDate}
                                            onChange={e => {
                                                formik.setFieldValue("networthDate", getLastDateOfFinancialYear());
                                            }}
                                            disabled={true}
                                            renderInput={(params) => (
                                                <StyledTextField
                                                    fullWidth
                                                    required
                                                    error={formik.touched.networthDate && Boolean(formik.errors.networthDate)}
                                                    helperText={formik.touched.networthDate && formik.errors.networthDate}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.occupation && Boolean(formik.errors.occupation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectOccupation}
                                        </InputLabel>
                                        <Select
                                            id="occupation"
                                            name="occupation"
                                            value={formik.values.occupation}
                                            onChange={e => {changeNatureOfBusinessOthers(e, true); formik.handleChange(e)}}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectOccupation}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.occupationList?.filter(opt => !opt.isParent)?.map(opt => <MenuItem value={opt.id}>{opt.occupationName}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.occupation && formik.errors.occupation}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.natureOfBusiness && Boolean(formik.errors.natureOfBusiness)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectNature}
                                        </InputLabel>
                                        <Select
                                            id="natureOfBusiness"
                                            name="natureOfBusiness"
                                            value={formik.values.natureOfBusiness}
                                            onChange={ (e)=>{formik.setFieldValue("natureOfBusinessOther", options?.occupationList.find(occupation => occupation.id == formik?.values?.occupation)?.isOtherAllowed ? "": options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.occupationName); formik.handleChange(e)}}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectNature}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.natureOfBusinessList?.map(opt => <MenuItem value={opt.id}>{opt.natureOfBusinessDesc}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.natureOfBusiness && formik.errors.natureOfBusiness}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                {formik.values.natureOfBusiness == 5 && <Grid item xs={12} md={6}>
                                    <StyledTextField id="natureOfBusinessOther" name="natureOfBusinessOther" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        disabled ={!(options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.isOtherAllowed)}
                                        value={formik?.values?.natureOfBusinessOther}
                                        error={formik.touched.natureOfBusinessOther && Boolean(formik.errors.natureOfBusinessOther)}
                                        helperText={formik.touched.natureOfBusinessOther && formik.errors.natureOfBusinessOther} fullWidth
                                        label={localeText?.AddressBusinessNature} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>}
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="tradingExp" name="tradingExp" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        inputProps={{ maxLength: 2 }}
                                        value={formik.values.tradingExp}
                                        error={formik.touched.tradingExp && Boolean(formik.errors.tradingExp)}
                                        helperText={formik.touched.tradingExp && formik.errors.tradingExp} fullWidth
                                        label={localeText?.AddressTradingYears} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.politicalAffiliation && Boolean(formik.errors.politicalAffiliation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectPolitical}
                                        </InputLabel>
                                        <Select
                                            id="politicalAffiliation"
                                            name="politicalAffiliation"
                                            value={formik.values.politicalAffiliation}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectPolitical}
                                                />
                                            }

                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.pepStatusList?.map(opt => <MenuItem value={opt.Code}>{opt.Description}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.politicalAffiliation && formik.errors.politicalAffiliation}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.sourceOfWealth && Boolean(formik.errors.sourceOfWealth)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectSource}
                                        </InputLabel>
                                        <Select
                                            id="sourceOfWealth"
                                            name="sourceOfWealth"
                                            value={formik.values.sourceOfWealth}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectSource}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.wealthMasterList?.map(opt => <MenuItem value={opt.id}>{opt.sourceOfWealthName}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.sourceOfWealth && formik.errors.sourceOfWealth}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="placeOfBirth" name="placeOfBirth" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        value={formik.values.placeOfBirth}
                                        error={formik.touched.placeOfBirth && Boolean(formik.errors.placeOfBirth)}
                                        helperText={formik.touched.placeOfBirth && formik.errors.placeOfBirth} fullWidth
                                        label={localeText?.AddressPlaceOfBirth} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.countryOfBirth && Boolean(formik.errors.countryOfBirth)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressCountryOfBirth}
                                        </InputLabel>
                                        <Select
                                            id="countryOfBirth"
                                            name="countryOfBirth"
                                            value={formik.values.countryOfBirth}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressCountryOfBirth}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            <MenuItem value={"India"}>{localeText?.AddressCountry}</MenuItem>
                                        </Select>
                                        <FormHelperText>{formik.touched.countryOfBirth && formik.errors.countryOfBirth}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControl>
                                        <FormControlLabel control={<Checkbox name="fatcaDeclaration" id="fatcaDeclaration" checked={formik.values.fatcaDeclaration} onChange={formik.handleChange} />}
                                            label={<Typography variant='body2'>
                                                {localeText?.AddressFatcaDeclaration}
                                            </Typography>}
                                        />
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={12} >
                                    <FormControl>
                                        <FormControlLabel control={<Checkbox name="agreementOfConsents" id="agreementOfConsents" checked={formik.values.agreementOfConsents}
                                            onChange={e => {
                                                handleAgreementOfConsents(e,"consent");
                                            }
                                            } />}
                                            label={
                                                <Typography variant='body2'>
                                                    {localeText?.AddressAgree} {localeText?.AddressConsents} {localeText?.AddressAnd} <Link target="_blank" onClick={()=>handleTermsAndConditions()} css={{ color: "#008FFF", cursor: "pointer", color: "primary", underline: "hover" }}>{localeText?.AddressTerms}</Link> {localeText?.AddressTradebulls}
                                                </Typography>}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControl>
                                        <FormControlLabel control={<Checkbox name="isAgreeMITC" id="isAgreeMITC" checked={formik.values.isAgreeMITC}
                                            onChange={e => {
                                                handleAgreementOfConsents(e,"mitcConsent");
                                            }
                                            } />}
                                            label={
                                                <Typography variant='body2'>
                                                    {localeText?.AddressIagreeMITC} {localeText?.AddressMITC}
                                                </Typography>}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControl>
                                        <FormControlLabel control={<Checkbox name="isDDPIConsent" id="isDDPIConsent" checked={formik.values.isDDPIConsent}
                                            onChange={e => {
                                                handleAgreementOfConsents(e,"ddpiConsent");
                                            }
                                            } />}
                                            label={
                                                <Typography variant='body2'>
                                                    {localeText?.AddressIagreeisDDPIConsent1} {localeText?.AddressDDPI} {localeText?.AddressIagreeisDDPIConsent2}
                                                </Typography>}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControl>
                                        <FormControlLabel control={<Checkbox name="isMTFDeclaration" id="isMTFDeclaration" checked={formik.values.isMTFDeclaration}
                                            onChange={e => {
                                                handleAgreementOfConsents(e,"mtfConsent");
                                            }
                                            } />}
                                            label={
                                                <Typography variant='body2'>
                                                    {localeText?.AddressIagreeisMTFDeclaration1} {localeText?.AddressIagreeisMTF} {localeText?.AddressIagreeisMTFDeclaration2}
                                                </Typography>}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item css={{ marginTop: "40px" }}>
                            <Button type="submit" variant='contained' color="secondary" disabled={!formik.values.fatcaDeclaration || !formik.values.isAgreeMITC || !formik.values.isDDPIConsent || !formik.values.agreementOfConsents || (formik.values.politicalAffiliation !== "Not Applicable")} >
                                {localeText?.profileSave}
                            </Button>
                        </Grid>

                    </ElevatedGrid>
                </PageLayout>
            </form>
            {loading && <FullScreenLoader />}
            {documentTypeOption && <ProofDialog setId={setId} onFile={onFile} getDocumentTypeURL={config.documentMaster + "2"} open={openInnerDialog} dialogTitle={documentTypePerName[documentTypeOption]}
             handleClose={toogleInnerDialog} data={documentTypeOption} limitPdfPages={1} />}
            {showUploadPopup &&
                <DialogForUpload open={showUploadPopup} handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={true} maxWidth='md'>
                    <UploadDialog
                        id={id}
                        multiple={numberOfImages} /// gives count to images to upload
                        handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        title={documentName}
                        imageArray={image ? image : null}
                        count={numberOfImages}  /// gives count to images to upload
                        onSave={(data) => { uploadImageProof(data); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}
            {showPdfPopup &&
                <DialogForUpload open={showPdfPopup} handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={false} maxWidth='md'>
                    <UploadPdf
                        title={"Upload Pdf"}
                        file={pdf.data}
                        pdfName={pdf.name}
                        handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        onUpload={(pdfData, pdfName) => { uploadPdfProof(pdfData, pdfName); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}

            <Popup
                open={openKRAVerifiedDataPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleKRAVerifiedDataEdittingPopup}>{localeText?.AddressConfirmation}</PopupTitle>
                <DialogContent >
                    {
                        Boolean(kRAData?.isKRAVerified) &&
                        <Grid sx={{ "& .MuiPaper-root": { color: '#24B7CC !important' } }}>
                        <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li>
                                <p>{localeText?.manualKRAAdressDataRecieved}</p>
                            </li>
                            <li>
                            <p>{localeText?.manualKRAAdressDataWillChange}</p>
                            </li>
                            <li>
                                <p>{localeText?.manualKRAAdressDataShouldUpload}</p>
                            </li>
                        </ul>
                    </Grid>
                    }

                </DialogContent>
                <DialogActions>
                    <Grid /* direction={"row-reverse"} */ alignItems={"center"} justifyContent={"flex-end"} container spacing={2} css={{ padding: "10px" }}>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={toggleKRAVerifiedDataEdittingPopup}>
                                {localeText?.AddressCancel}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="primary" onClick={() => { toggleKRAVerifiedDataEdittingPopup(); toggleEdit(); }}>
                               {localeText?.AddressOk}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Popup>
            {
                <Popup
                    open={consentOpen}
                    maxWidth={"lg"}
                >
                    <PopupTitle onClose={handleConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.AddressInstructions}
                        <Typography variant="body1" style={{ color: "#939393" }}>
                            <span style={{ fontWeight: "600", color: "#939393" }}>{localeText?.AddressNoWaiver}</span > {localeText?.AddressForBearance}
                        </Typography></PopupTitle>
                    <DialogContent>
                        <Table>
                            <TableHead>
                                <TableCell style ={{background:"#24B7CC", color: "white"}}>Consent Tearms</TableCell>
                                <TableCell style ={{background:"#24B7CC",borderLeft:"2px solid rgb(216 216 216)", color: "white"}}>Yes/ No</TableCell>
                            </TableHead>
                            <TableBody>
                            <TableRow>
                                {/* Concent to be not written in Language files since the statement below is as per circulars given by SEBI and other government institutes published time to time. */}
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To receive / accept each and every credit and pledge instruction in my account`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"creditPledgeInstruction"} id={"creditPledgeInstruction"} checked={checkedField["creditPledgeInstruction"]} onChange={(e) => onConsentChange("creditPledgeInstruction", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To send Electronic Transaction, Holding Statement, ECN / Bill & all correspondence at 1st Holder Email ID stated in KYC`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"electronicContractNoteNstatement"} id={"electronicContractNoteNstatement"} checked={checkedField["electronicContractNoteNstatement"]} onChange={(e) => onConsentChange("electronicContractNoteNstatement", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To share email id with Registrar & Transfer Agent (RTA)`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"shareEmailWithRegistrarNrta"} id={"shareEmailWithRegistrarNrta"} checked={checkedField["shareEmailWithRegistrarNrta"]} onChange={(e) => onConsentChange("shareEmailWithRegistrarNrta", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Dividend / Interest to receive in bank account stated in KYC via ECS`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"dividendInterestinBankAc"} id={"dividendInterestinBankAc"} checked={checkedField["dividendInterestinBankAc"]} onChange={(e) => onConsentChange("dividendInterestinBankAc", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To avail facility of Internet Trading & Wireless Technology`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"internetTrading"} id={"internetTrading"} checked={checkedField["internetTrading"]} onChange={(e) => onConsentChange("internetTrading", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To receive Annual Report in Electronic mode`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"electronicAnnualReport"} id={"electronicAnnualReport"} checked={checkedField["electronicAnnualReport"]} onChange={(e) => onConsentChange("electronicAnnualReport", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To receive Rights & Obligations, RDD, Guidance Note, Policies & Procedures & all non mandatory documents in electronic and also displayed for information on website www.tradebulls.in`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"rightObligation"} id={"rightObligation"} checked={checkedField["rightObligation"]} onChange={(e) => onConsentChange("rightObligation", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To receive Physical Delivery Instruction Slip`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                    <FormControl>
                                        <FormControlLabel style={{margin:0}} control={<Checkbox name={"receiveDisslip"} id={"receiveDisslip"} checked={checkedField["receiveDisslip"]} onChange={(e) => onConsentChange("receiveDisslip", e.target.checked)} />}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`DP Account Statement`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`As per SEBI Regulations`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`CAS Flag`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"casFlag"} id={"casFlag"} checked={checkedField["casFlag"]} onChange={(e) => onConsentChange("casFlag", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`CAS Mode`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`eCAS`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Preferred Depository`}</TableCell>
                                <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>{`CDSL`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`Details of any action / proceedings initiated / pending / taken by SEBI / Stock exchange / any other authority against the applicant / constituent or its Partners / promoters / whole time directors /authorized persons in charge of dealing in securities during the last 3 years`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                    <FormControl>
                                        <FormControlLabel style={{margin:0}} control={<Checkbox name={"pastAction"} id={"pastAction"} checked={checkedField["pastAction"]} onChange={(e) => onConsentChange("pastAction", e.target.checked)} />}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            {(checkedField["pastAction"]) &&
                                <TableRow>
                                    <FormControl fullWidth >
                                        <TextField id="pastActionReason" label="Details of action" variant="outlined" InputLabelProps={{ shrink: true }} inputProps={{maxLength: 100,}} value={checkedField["pastActionReason"]} onChange={(e) => {
                                                if (e.currentTarget.value.match(/^[0-9a-z ]+$/)){
                                                    onConsentChange("pastActionReason", e.currentTarget.value)
                                                }
                                            }}/>
                                    </FormControl>
                                </TableRow>
                            }
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Client Authorisation to maintain Running Account`}</TableCell>
                                <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                                    
                                <Select
                                    id="authRunningAccount"
                                    name="authRunningAccount"
                                    value={checkedField["authRunningAccount"]}
                                    onChange={(e)=>{onConsentChange("authRunningAccount", e?.target?.value)}}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={"Running Authorization"}
                                        />
                                    }
                                >
                                    <MenuItem value=""></MenuItem>
                                    <MenuItem value={"Quarterly"}>{"Quarterly"}</MenuItem>
                                    <MenuItem value={"Monthly"}>{"Monthly"}</MenuItem>
                                </Select>
                                </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
                    </DialogContent>   
                        <DialogActions style={{display: "-webkit-box"}}>
                            <Grid container>
                                <Grid item xs={11}>
                                <Typography variant={"body1"} style={{ marginTop: "5px", color: "#858585" }} >
                                    <span style={{ fontWeight: "600" }}>Note:To register for Easi please visit website <Link target='_blank' href="https://www.cdslindia.com">www.cdslindia.com</Link>, where BO can view ISIN balances, transactions & portfolio online.</span>
                                </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button variant="contained" color="primary" disabled={isConsentSatisfied} onClick={handleConsentClose}>
                                        {localeText?.AddressOk}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions> 
                </Popup>
            }
            {
        <Popup
          open={mitcConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>{localeText?.AddressMITC}</PopupTitle>
          <DialogContent>
            <Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MITCContentData?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" onClick={handleMitcConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
      {
        <Popup
          open={ddpiConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle onClose={handleDdpiConsentClose} customCSS={{ textAlign: "center" }}>{localeText?.AddressDDPI}</PopupTitle>
          <DialogContent>
            <Grid padding={'0px 30px 1px 30px'}>
            <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center', paddingBottom:'10px'}}>
                <Typography variant='p'>{localeText.consentDDPITitle}</Typography>
                </Grid>
                <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography variant='p'>{localeText.consentDDPIDesc}</Typography>
                </Grid>
                <Grid padding={'0px 30px 0px 15px'}>
               <Table>
                            <TableHead>
                                <TableCell style ={{background:"#24B7CC", color: "white"}}>Consent Tearms</TableCell>
                                <TableCell style ={{background:"#24B7CC",borderLeft:"2px solid rgb(216 216 216)", color: "white"}}>Yes/ No</TableCell>
                            </TableHead>
                            <TableBody>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{localeText?.consentDDPI1}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"transferOfSecurities"} id={"transferOfSecurities"} checked={isDdpiCheckedField["transferOfSecurities"]} onChange={(e) => onDdpiConsentChange("transferOfSecurities", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{localeText?.consentDDPI2}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"pledgingRepledgingOfSecurities"} id={"pledgingRepledgingOfSecurities"} checked={isDdpiCheckedField["pledgingRepledgingOfSecurities"]} onChange={(e) => onDdpiConsentChange("pledgingRepledgingOfSecurities", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{localeText?.consentDDPI3}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"mutualFundTransactions"} id={"mutualFundTransactions"} checked={isDdpiCheckedField["mutualFundTransactions"]} onChange={(e) => onDdpiConsentChange("mutualFundTransactions", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{localeText?.consentDDPI4}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"tenderingSharesInOpenOffers"} id={"tenderingSharesInOpenOffers"} checked={isDdpiCheckedField["tenderingSharesInOpenOffers"]} onChange={(e) => onDdpiConsentChange("tenderingSharesInOpenOffers", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" disabled={isDDPIConsentSatisfied} onClick={handleDdpiConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
      {
        <Popup
          open={mtfConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>{"Rights & obligations of stock brokers & clients for Margin Trading Facility (MTF)"}</PopupTitle>
          <DialogContent>
            <Grid>
                <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTrading}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientRights}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClient?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerRightsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForTerminationOfRelationTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForTerminationOfRelation?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTradingFacility}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
              {MTFConsentMarginTradingQuestions.map((item, i) => (
                <ListItem key={i} sx={{ display: "list-item" }}>
                <ListItemText>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{item.instruction}</Typography>
                </ListItemText>
                {Array.isArray(MTFConsentForTermsofTBAnswer[i].instruction) ? (
                    MTFConsentForTermsofTBAnswer[i].instruction.map((answerItem, j) => (
                    <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li key={j}> {answerItem}</li>
                    </ul>
                    ))
                ) : (
                    <ListItemText primary={MTFConsentForTermsofTBAnswer[i].instruction} />
                )}
                </ListItem>))}
              </List>             
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
            <Button variant="contained" color="primary" onClick={handleMtfConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
            </Button>                   
          </DialogActions>
        </Popup>
      }

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default AddressDetails;